import { motion, useReducedMotion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

// When the official Glovo ordering link is available, set GLOVO_URL to the URL.
// The "PRÓXIMAMENTE EN GLOVO" button automatically becomes a live link — no redesign needed.
const GLOVO_URL = null;

const Delivery = () => {
  const reduce = useReducedMotion();

  return (
    <section id="delivery" data-testid="delivery-section" className="bg-brand-charcoal text-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-14 md:py-20 grid lg:grid-cols-2 gap-8 lg:gap-16 items-center">
        <Reveal className="text-center lg:text-left">
          <p className="text-sm font-semibold uppercase tracking-widest text-brand-pink">
            DELIVERY 🛵
          </p>
          <h2 className="mt-3 font-display font-bold tracking-tight text-4xl md:text-5xl">
            ¿CROC en casa?
          </h2>
          <p className="mt-4 text-base md:text-lg text-white/85 leading-relaxed max-w-xl mx-auto lg:mx-0">
            Muy pronto podrás pedir CROC LAB en Glovo.
          </p>
          <div className="mt-8">
            {GLOVO_URL ? (
              <a
                data-testid="delivery-glovo-button"
                href={GLOVO_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-brand-pink text-white text-base font-semibold uppercase tracking-wide rounded-full px-10 py-4 hover:scale-105 transition-transform"
              >
                PRÓXIMAMENTE EN GLOVO
                <ArrowRight className="w-4 h-4" aria-hidden="true" />
              </a>
            ) : (
              <span
                data-testid="delivery-glovo-button"
                aria-disabled="true"
                className="inline-flex items-center justify-center gap-2 bg-brand-pink text-white text-base font-semibold uppercase tracking-wide rounded-full px-10 py-4 cursor-default select-none"
              >
                PRÓXIMAMENTE EN GLOVO
              </span>
            )}
          </div>
        </Reveal>
        <Reveal delay={0.15} className="flex justify-center lg:justify-end">
          <motion.img
            src="/brand/delivery-scooter.png"
            alt="Scooter de reparto rosa de CROC LAB"
            data-testid="delivery-scooter-image"
            className="w-52 md:w-64 lg:w-80 h-auto"
            animate={reduce ? undefined : { y: [0, -10, 0] }}
            transition={{ duration: 4.5, repeat: Infinity, ease: "easeInOut" }}
          />
        </Reveal>
      </div>
    </section>
  );
};

export default Delivery;
